var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"a","points":"1.383 47.308 32 16.692 62.617 47.308"}));
}

Chevron.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Chevron;

Chevron.default = Chevron;
